let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1Qtm6")).then(() => parcelRequire('2ROge'));